<div class="filter-bar">
  <div class="filter-bar__search">
    <p-dropdown
      *ngIf="searchByOptions?.length"
      [options]="searchByOptions"
      [(ngModel)]="searchBy"
      (ngModelChange)="setParamsToRoute()"
      optionLabel="name"
      optionValue="key"
      class="filter-bar__search-by"
      placeholder="Search By"
    >
    </p-dropdown>
    <span class="filter-bar__search__bar">
      <img src="./assets/images/gray-search.svg" alt="Search Icon" />
      <input
        [(ngModel)]="searchText"
        (ngModelChange)="handleSearchChanged()"
        class="filter-bar__search__input"
        type="text"
        [placeholder]="globalSearchParamName === 'filter_by_claim_number' ? 'Search By Claim Number...' : 'Search...'"
      />
    </span>
  </div>
  <div class="filter-bar__add-options">
    <button
      *ngIf="filterByOptions?.length"
      (click)="filterOverlay.toggle($event)"
      class="filter-bar__add-options__filter-btn"
    >
      <img src="./assets/images/Group.svg" alt="" />
      Filter By
      <img
        class="open-dropdown"
        src="./assets/images/icon-chevron-down 2.svg"
        alt=""
      />
    </button>
    <p-dropdown
      *ngIf="sortByOptions?.length"
      [options]="sortByOptions"
      optionLabel="name"
      class="filter-ba__add-optionsr__order-by"
      placeholder="Order By: Default"
      [(ngModel)]="sortBy"
      optionValue="key"
      (ngModelChange)="setParamsToRoute()"
    >
      <ng-template let-selectedItem pTemplate="selectedItem">
        Order By: {{ selectedItem.name ?? "Default" | truncate : 10 }}
      </ng-template>
    </p-dropdown>
  </div>
</div>
<div *ngIf="activeFilters.length" class="applied-filters">
  <div
    class="applied-filters_item"
    *ngFor="let activeFilter of activeFilters"
    (click)="removeActiveFilter(activeFilter)"
  >
    <img
      class="applied-filters_cross"
      src="./assets/images/white-cross.svg"
      alt="Remove"
    />
    {{ activeFilter?.label | activeFilterName }}
  </div>

  <div
    class="applied-filters_item applied-filters_remove-all-item"
    *ngIf="activeFilters?.length"
    (click)="resetAllFilters()"
  >
    <img
      class="applied-filters_cross"
      src="./assets/images/black-cross.svg"
      alt="Remove all"
    />

    Remove All Filters
  </div>
</div>
<p-overlayPanel
  #filterOverlay
  appendTo="body"
  styleClass="table-filter-overlay-panel"
>
  <form *ngIf="filterForm" [formGroup]="filterForm" class="filter-overlay">
    <div class="filter-overlay__content">
      <div
        *ngFor="let filterOption of filterByOptions; let index = index"
        class="filter-overlay__item"
      >
        <label class="filter-overlay__item__label">
          {{ filterOption.name }}
          <app-info-icon
            *ngIf="filterOption.tooltip"
            [tooltip]="filterOption.tooltip"
          ></app-info-icon>
          <i
            *ngIf="filterOption.isLoading"
            class="fa-spin fas fa-spinner ms-2"
          ></i>
        </label>
        <p-dropdown
          *ngIf="
            !filterOption.isAutocomplete &&
            !filterOption.isText &&
            !filterOption.isCheckbox &&
            !filterOption.isMultiSelect &&
            !filterOption.isDateRange &&
            !filterOption.isDate &&
            !filterOption.isNumberRange
          "
          [options]="filterOption.options || []"
          [formControlName]="filterOption.key"
          optionValue="id"
          optionLabel="name"
          appendTo="body"
          [placeholder]="
            filterOption.placeholder && filterOption.name
              ? 'Filter By ' + filterOption.placeholder
                ? filterOption.placeholder
                : filterOption.name
              : 'Filter By Status'
          "
        >
        </p-dropdown>
        <p-multiSelect
          *ngIf="filterOption.isMultiSelect"
          [options]="filterOption.options || []"
          [formControlName]="filterOption.key"
          optionValue="id"
          optionLabel="name"
          appendTo="body"
          [filter]="true"
          [showClear]="true"
          [maxSelectedLabels]="2"
          selectedItemsLabel="{0} states selected"
          [placeholder]="filterOption.placeholder || filterOption.name"
        ></p-multiSelect>
        <input
          *ngIf="filterOption.isText"
          type="text"
          class="form-control"
          [formControlName]="filterOption.key"
          [placeholder]="filterOption.placeholder || filterOption.name"
        />
        <p-dropdown
          *ngIf="filterOption.isAutocomplete"
          [options]="filterOption.options || []"
          [formControlName]="filterOption.key"
          (onFilter)="handleAutocompleteSearch($event, index)"
          [optionValue]="filterOption.optionValue ?? 'id'"
          [filterMatchMode]="'alwaysTrue'"
          (onShow)="handleAutocompletePanelShow(index)"
          [placeholder]="
            filterOption.placeholder && filterOption.name
              ? 'Filter By ' + filterOption.placeholder
                ? filterOption.placeholder
                : filterOption.name
              : 'Filter By Status'
          "
          [filter]="true"
          [autofocusFilter]="true"
          [emptyMessage]="
            filterOption.isLoading
              ? 'Loading...'
              : filterOption.options?.length
              ? ''
              : 'No Results Found'
          "
          [emptyFilterMessage]="
            filterOption.isLoading
              ? 'Loading...'
              : filterOption.options?.length
              ? ''
              : 'No Results Found'
          "
          appendTo="body"
        >
          <ng-template let-item pTemplate="item">
            {{ getOptionLabel(item, index) }}
          </ng-template>
          <ng-template let-item pTemplate="selectedItem">
            {{ getOptionLabel(item, index) }}
          </ng-template>
        </p-dropdown>
        <ng-container *ngIf="filterOption.isCheckbox">
          <div class="checboxes-container">
            <ng-container *ngFor="let option of filterOption.options">
              <div class="item">
                <label [for]="option.id">
                  <span
                    *ngIf="option.color"
                    class="color"
                    [style]="{ 'background-color': option.color }"
                  ></span>
                  {{ option.name | truncate : 30 }}
                </label>
                <p-checkbox
                  [formControl]="filterForm.controls[filterOption.key]"
                  [inputId]="option.id + ''"
                  [value]="option.id"
                  [binary]="false"
                ></p-checkbox>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="filterOption.isDateRange">
          <div class="date-range-selector">
            <p-calendar
              appendTo="body"
              class="w-100"
              [placeholder]="filterOption?.placeholder || 'Select Date Range'"
              [formControl]="filterForm.controls[filterOption.key]"
              selectionMode="range"
              [inputStyle]="{ width: '100%' }"
              [dateFormat]="'mm-dd-yy'"
              [readonlyInput]="true"
              [showClear]="true"
            >
            </p-calendar>
            <p *ngIf="filterOption.tooltip" class="filter-overlay__item__hint">
              {{ filterOption.tooltip }}
            </p>
          </div>
        </ng-container>
        <ng-container *ngIf="filterOption.isNumberRange">
          <div class="number-range-selector">
            <input
              type="text"
              inputmode="decimal"
              numbersOnly
              additionalAllowedSymbols="."
              class="form-control"
              [formControlName]="filterOption.minKey || filterOption.key + '_min'"
              placeholder="Min"
            />
            <span class="number-range-selector__sep">–</span>
            <input
              type="text"
              inputmode="decimal"
              numbersOnly
              additionalAllowedSymbols="."
              class="form-control"
              [formControlName]="filterOption.maxKey || filterOption.key + '_max'"
              placeholder="Max"
            />
          </div>
          <p
            *ngIf="isNumberRangeInvalid(filterOption)"
            class="filter-overlay__item__hint filter-overlay__item__hint--error"
          >
            Min cannot be greater than max
          </p>
        </ng-container>
        <ng-container *ngIf="filterOption.isDate">
          <div class="date-range-selector">
            <p-calendar
              appendTo="body"
              class="w-100"
              [placeholder]="filterOption?.placeholder || 'Select Date'"
              [formControl]="filterForm.controls[filterOption.key]"
              [inputStyle]="{ width: '100%' }"
              [dateFormat]="'mm-dd-yy'"
              [readonlyInput]="true"
              [showClear]="true"
            >
            </p-calendar>
            <small *ngIf="filterOption.helperText" class="date-filter-helper">{{ filterOption.helperText }}</small>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="filter-overlay__btns">
      <button
        (click)="resetFilters(); filterOverlay.toggle($event)"
        class="outline-btn"
      >
        Clear Filters
      </button>
      <button
        (click)="applyFilters(filterOverlay, $event)"
        class="regular-btn regular-btn_main"
        [disabled]="hasInvalidNumberRange"
      >
        Apply
      </button>
    </div>
  </form>
</p-overlayPanel>
